/**
 * Finnish metering point ids (käyttöpaikkatunnus) are 18-digit GS1 GSRNs
 * starting with "64", ending in a GS1 mod-10 check digit. The check is
 * advisory in the UI: a mistyped number silently orphans the Datahub
 * authorization matching, so we warn — but legacy free-text values must not
 * block saving unrelated settings.
 */
/** Strip all whitespace (users paste grouped digits like "6430 0696 …"). */
export function normalizeMeterNumber(value: string): string {
  return value.replace(/\s+/g, '')
}

export function isValidMeterNumber(value: string): boolean {
  const v = normalizeMeterNumber(value)
  if (!/^64\d{16}$/.test(v)) { return false }
  const digits = v.split('').map(Number)
  const check = digits.pop() as number
  const sum = digits.reverse().reduce((acc, d, i) => acc + d * (i % 2 === 0 ? 3 : 1), 0)
  return (10 - (sum % 10)) % 10 === check
}
